"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = exports.RadioGroup = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var InternalCheckbox_1 = require("../Checkbox/InternalCheckbox");
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var hooks_1 = require("../utils/hooks");
function InternalRadio(_a) {
    var radioType = _a.radioType, restProps = tslib_1.__rest(_a, ["radioType"]);
    var prefix = ConfigProvider_1.usePrefix('radio');
    if (radioType === 'button') {
        prefix = utils_1.concat(prefix, 'btn');
    }
    return react_1.default.createElement(InternalCheckbox_1.InternalCheckbox, tslib_1.__assign({}, restProps, { type: "radio", prefixCls: prefix }));
}
var groupContext = react_1.createContext(null);
function RadioGroup(_a) {
    var valueFromProps = _a.value, _b = _a.defaultValue, defaultValue = _b === void 0 ? null : _b, disabled = _a.disabled, onChangeFromProps = _a.onChange, _c = _a.radioType, radioType = _c === void 0 ? 'default' : _c, size = _a.size, children = _a.children;
    var onChange = react_1.useCallback(function (v) {
        onChangeFromProps === null || onChangeFromProps === void 0 ? void 0 : onChangeFromProps(v);
    }, [onChangeFromProps]);
    var _d = hooks_1.useValue({ valueFromProps: valueFromProps, defaultValue: defaultValue, onChange: onChange }), value = _d.value, setValue = _d.setValue;
    var onRadioChange = react_1.useCallback(function (v) {
        setValue(v);
    }, [setValue]);
    var context = react_1.useMemo(function () { return ({
        value: value !== null && value !== void 0 ? value : undefined,
        disabled: disabled,
        onRadioChange: onRadioChange,
        radioType: radioType,
        size: size
    }); }, [value, disabled, onRadioChange, radioType, size]);
    return (react_1.default.createElement(groupContext.Provider, { value: context }, children));
}
exports.RadioGroup = RadioGroup;
function Radio(_a) {
    var _b;
    var value = _a.value, restProps = tslib_1.__rest(_a, ["value"]);
    var radioGroup = react_1.useContext(groupContext);
    if (radioGroup) {
        if (utils_1.isDev && value === undefined) {
            // eslint-disable-next-line no-console
            console.warn('`value` must be set when `<Radio>` used in `<RadioGroup>`');
        }
        var radioProps = tslib_1.__assign({}, restProps);
        // 只有未选中的 radio 被点击时才会触发 onchange 事件，实际传入的 checked 参数只可能是 `true`
        radioProps.onChange = function (checked) {
            var _a;
            (_a = restProps.onChange) === null || _a === void 0 ? void 0 : _a.call(restProps, checked);
            radioGroup.onRadioChange(value);
        };
        radioProps.checked = radioGroup.value === value;
        radioProps.disabled = restProps.disabled || radioGroup.disabled;
        radioProps.radioType = radioGroup.radioType;
        radioProps.size = (_b = radioProps.size) !== null && _b !== void 0 ? _b : radioGroup.size;
        return react_1.default.createElement(InternalRadio, tslib_1.__assign({}, radioProps));
    }
    return react_1.default.createElement(InternalRadio, tslib_1.__assign({}, restProps));
}
exports.Radio = Radio;
//# sourceMappingURL=index.js.map